import { render, staticRenderFns } from "./CompensatoryHours.vue?vue&type=template&id=8f59538a&scoped=true&"
import script from "./CompensatoryHours.vue?vue&type=script&lang=js&"
export * from "./CompensatoryHours.vue?vue&type=script&lang=js&"
import style0 from "./CompensatoryHours.vue?vue&type=style&index=0&id=8f59538a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f59538a",
  null
  
)

export default component.exports